"use client";

import { c as _c } from "react/compiler-runtime";
import { Check } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { locales, supportedLocales } from "@/config/locales";
import { useLocale } from "@/hooks/use-locale";
import { cn } from "@/lib/utils";
interface LanguageSwitcherProps {
  className?: string;
  variant?: "default" | "code";
}
export function LanguageSwitcher(t0) {
  const $ = _c(28);
  const {
    className,
    variant: t1
  } = t0;
  t1 === undefined ? "default" : t1;
  const {
    t
  } = useTranslation();
  const {
    currentLocale,
    changeLanguage
  } = useLocale();
  const [isOpen, setIsOpen] = useState(false);
  let t2;
  if ($[0] !== changeLanguage) {
    t2 = locale => {
      changeLanguage(locale);
      setIsOpen(false);
    };
    $[0] = changeLanguage;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleLanguageSelect = t2;
  let t3;
  if ($[2] !== className) {
    t3 = cn("inline-flex items-center gap-1.5 rounded-full border border-[#e0e0e0] bg-white px-3 py-1.5 text-sm font-medium outline-none hover:bg-[#f8f8f8]", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <g clipPath="url(#clip0_lang)"><path d="M14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8.00001 14.6666M14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 8.00001 1.33325M14.6667 7.99992H1.33334M8.00001 14.6666C4.31811 14.6666 1.33334 11.6818 1.33334 7.99992M8.00001 14.6666C6.28817 12.8692 5.33334 10.4821 5.33334 7.99992C5.33334 5.51775 6.28817 3.13069 8.00001 1.33325M8.00001 14.6666C9.71185 12.8692 10.6667 10.4821 10.6667 7.99992C10.6667 5.51775 9.71185 3.13069 8.00001 1.33325M1.33334 7.99992C1.33334 4.31802 4.31811 1.33325 8.00001 1.33325" stroke="#3073D5" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none" className="shrink-0">{t4}<defs><clipPath id="clip0_lang"><rect width="16" height="16" fill="white" /></clipPath></defs></svg>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== currentLocale) {
    t6 = currentLocale.toUpperCase();
    $[6] = currentLocale;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <span className="text-[0.82rem] font-medium text-[#333]">{t6}</span>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className="shrink-0 text-[#888]"><polyline points="6 9 12 15 18 9" /></svg>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t3 || $[12] !== t7) {
    t9 = <PopoverTrigger asChild={true}><button type="button" aria-label="Language switcher" className={t3}>{t5}{t7}{t8}</button></PopoverTrigger>;
    $[11] = t3;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t("sidebar.selectLanguage", {
      defaultValue: "Select language"
    });
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <div className="px-2 py-1 text-xs text-muted-foreground">{t10}</div>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== currentLocale || $[19] !== handleLanguageSelect) {
    t12 = supportedLocales.map(locale_0 => {
      const localeData = locales[locale_0];
      const isCurrent = locale_0 === currentLocale;
      return <button key={locale_0} type="button" onClick={() => handleLanguageSelect(locale_0)} className="flex w-full items-center justify-between rounded-sm px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground"><span className="flex items-center gap-2"><span className="text-base leading-none">{localeData.emoji}</span><span className="text-xs font-semibold">{localeData.flag}</span><span>{localeData.name}</span></span>{isCurrent ? <Check className="size-3.5" /> : null}</button>;
    });
    $[18] = currentLocale;
    $[19] = handleLanguageSelect;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <PopoverContent align="end" className="w-44 p-1" onClick={_temp} onKeyDown={_temp2}>{t11}{t12}</PopoverContent>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== isOpen || $[25] !== t13 || $[26] !== t9) {
    t14 = <Popover open={isOpen} onOpenChange={setIsOpen}>{t9}{t13}</Popover>;
    $[24] = isOpen;
    $[25] = t13;
    $[26] = t9;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(event) {
  return event.stopPropagation();
}